/**
 * Holt einen Wert aus einem verschachtelten Objekt anhand eines Pfades im Format "a.b.c".
 * - Gibt den Wert zurück, wenn der Pfad vollständig aufgelöst werden kann.
 * - Gibt `null` zurück, wenn ein Teil des Pfades fehlt oder `null` ist.
 *
 * Beispiel:
 *   const obj = {a: {b: {c: 123} } };
 *   getValueByPath(obj, "a.b.c"); // -> 123
 *   getValueByPath(obj, "a.x.c"); // -> null
 */

export const getValueByPath = (obj: any, path: string) => {
	return (
		path.split('.').reduce((acc, key) => {
			if (acc === undefined || acc === null) return null;
			return acc[key];
		}, obj) ?? null
	);
};
